import { useEffect, useState } from "react";

import { Button } from "../ui/button";
import { Checkbox } from "../ui/checkbox";
import {
  Dialog,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPopup,
  DialogTitle,
} from "../ui/dialog";
import { Label } from "../ui/label";

/**
 * Asks what attached files or folders are for when no Action chip says so:
 * sources for the Brain, or material for this one message. "Always ingest in
 * this project" stores the project's `alwaysIngestAttachments`, which project
 * settings turn back off.
 */
export function AttachIngestDialog(props: {
  readonly open: boolean;
  /** How many files and folders are waiting, for the description. */
  readonly count: number;
  readonly onChoose: (choice: { ingest: boolean; alwaysIngest: boolean }) => void;
  readonly onCancel: () => void;
}) {
  const [alwaysIngest, setAlwaysIngest] = useState(false);
  useEffect(() => {
    if (props.open) setAlwaysIngest(false);
  }, [props.open]);
  const noun = props.count === 1 ? "this item" : `these ${props.count} items`;
  return (
    <Dialog
      open={props.open}
      onOpenChange={(open) => {
        if (!open) props.onCancel();
      }}
    >
      <DialogPopup className="max-w-md" data-attach-ingest-dialog>
        <DialogHeader>
          <DialogTitle>Ingest into Brain?</DialogTitle>
          <DialogDescription>
            Ingest adds {noun} to the project&apos;s Brain as sources. Just attach sends{" "}
            {props.count === 1 ? "it" : "them"} with this message only.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:items-center sm:justify-between">
          <Label className="flex items-center gap-2 font-normal text-muted-foreground text-sm">
            <Checkbox
              checked={alwaysIngest}
              onCheckedChange={(checked) => setAlwaysIngest(Boolean(checked))}
            />
            Always ingest in this project
          </Label>
          <div className="flex gap-2">
            <Button
              variant="ghost"
              disabled={alwaysIngest}
              onClick={() => props.onChoose({ ingest: false, alwaysIngest: false })}
            >
              Just attach
            </Button>
            <Button autoFocus onClick={() => props.onChoose({ ingest: true, alwaysIngest })}>
              Ingest into Brain
            </Button>
          </div>
        </DialogFooter>
      </DialogPopup>
    </Dialog>
  );
}
